<!--
 * @Auther: 罗耀祖
 * @Date: 2022-08-22 17:01:46
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-08-24 18:04:48
 * @name: 绑定erp
 * @Description: 绑定erp
 * @FilePath: \preSaleNafterSaleBackstage\src\components\pianoCompanyManage\dialog\erp-bind.vue
 * @Author: desktop
-->
<template>
  <div>
    <addNeditDialog ref="addNeditDialog" title="绑定ERP" @close="close">
      <template v-slot:form>
        <div class="search">
          <el-input
            size="mini"
            v-model="agency_name"
            placeholder="请输入琴行..."
            clearable
          ></el-input>
          <el-button size="mini" type="primary" @click="getList"
            >搜索</el-button
          >
        </div>
        <div class="list">
          <div class="loading" v-if="loading">
            <i class="el-icon-loading"></i>
          </div>
          <div class="no-message" v-else-if="!list || list.length === 0">
            暂无数据
          </div>
          <template v-else>
            <div
              class="item"
              v-for="item of list"
              :key="item.id"
              @click="itemClickHandler(item)"
            >
              <span>{{ item.name }}</span>
              <i class="el-icon-arrow-right"></i>
            </div>
          </template>
        </div>
      </template>
    </addNeditDialog>
  </div>
</template>
<script>
import addNeditDialog from "@/components/pianoCompanyManage/dialog/addNeditDialog.vue";
import { debounceation } from "@/utils/decorator";
import { getErpAgency } from "@/api/pianoCompanyManage/pianoCompanyManage.api";
export default {
  name: "pianoCompanyManage-erpBind",
  components: {
    addNeditDialog,
  },
  data() {
    return {
      agency_id: "",
      agency_name: "",
      loading: false,
      list: [],
    };
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗
     */
    open(row) {
      this.agency_id = row?.id ?? "";
      this.agency_name = row?.agency_name ?? "";
      this.getList();
      this.$refs.addNeditDialog.open();
    },
    getList() {
      this.loading = true;
      getErpAgency({
        agency_name: this.agency_name,
      })
        .then((res) => {
          this.list = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭弹窗回调
     */
    close() {
      this.agency_id = "";
      this.agency_name = "";
      this.list = [];
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭弹窗
     */
    @debounceation(300)
    cancel() {
      this.$refs.addNeditDialog.close();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 琴行项点击
     */
    @debounceation(300)
    itemClickHandler(item) {
      this.$emit("confirm", { agency_id: this.agency_id, erp: item });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.form {
  padding: 0;
  padding-bottom: 30px;
}
.search {
  width: 80%;
  @extend .extend-flex-start;
  .el-button {
    margin-left: 20px;
  }
}
.list {
  width: 100%;
  max-height: 600px;
  overflow-y: auto;
  padding: 20px 0;
  @extend .extend-flex-column-center;
}
.loading {
  padding: 30px 0;
  font-size: 20px;
}
.no-message {
  padding: 30px 0;
  font-size: 20px;
  color: $Vars-font-placeholder-color;
}
.item {
  width: 80%;
  box-sizing: border-box;
  padding: 14px 10px;
  font-size: 16px;
  border-bottom: 1px solid $Vars-border-second-color;
  @extend .extend-flex-spacebetween;
  @extend .extend-clickElement;
}
</style>